const rootState = {
    root: 'parent',
    url: '/sink',
    abstract: true,
    template: '<ui-view></ui-view>'
};

const mainState = {
    url: '',
    controller: require('./main/mainCtrl'),
    template: require('./main/main.html')
};

export default function (app) {
    app.config($stateProvider => {
        $stateProvider
            .state('sink', rootState)
            .state('sink.main', mainState);
    });
}



// WEBPACK FOOTER //
// ./Client/app/sink/routes.js